<template>
    <div>
        <el-dialog title="商业承兑汇票信息" :visible.sync="isDetail" width="1200px" :before-close="onDetailClose" :close-on-click-modal="false">
            <div class="hw-content">
                <el-collapse v-model="activeNames">
                    <el-collapse-item title="基础信息" name="1">
                        <el-descriptions title="" :column="2" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="项目ID">
                                <div class="rows">{{ result.Credit_CommercialBill_ID }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="创建时间">
                                <div class="rows">{{ result.Credit_CommercialBill_AddTime }}</div>
                            </el-descriptions-item>
                            <el-descriptions-item label="汇票编号">{{ result.Credit_CommercialBill_SN }}</el-descriptions-item>
                            <el-descriptions-item label="混合付款ID">
                                <div style="display: flex; align-items: center" v-if="result.Credit_CommercialBill_PaymentIDChange == 'true'">
                                    <el-input v-model="result.Credit_CommercialBill_PaymentID" placeholder="" clearable class="el-select-medium"></el-input>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditCommercialBillPaymentID()">保存</el-button>
                                </div>
                                <span v-else>{{ result.Credit_CommercialBill_PaymentID }}</span>
                            </el-descriptions-item>
                            <el-descriptions-item label="客户名称">{{ result.Credit_CommercialBill_CustomerName }}</el-descriptions-item>
                            <el-descriptions-item label="客户统一编号">{{ result.Credit_CommercialBill_CustomerUniformCode }}</el-descriptions-item>
                            <el-descriptions-item label="金额">{{ result.Credit_CommercialBill_ProjectMoney | thousandSeparator }}</el-descriptions-item>
                            <el-descriptions-item label="分配余额">{{ result.Credit_CommercialBill_Balance | thousandSeparator }}</el-descriptions-item>
                            <el-descriptions-item label="出票日期">{{ result.Credit_CommercialBill_IssueDate }}</el-descriptions-item>
                            <el-descriptions-item label="到期日期">{{ result.Credit_CommercialBill_DueDate }}</el-descriptions-item>
                            <el-descriptions-item label="承兑人">{{ result.Credit_CommercialBill_Acceptor }}</el-descriptions-item>
                            <el-descriptions-item label="前手背书人">{{ result.Credit_CommercialBill_FormerEndorser }}</el-descriptions-item>
                            <el-descriptions-item label="类型">{{ result.Credit_CommercialBill_TypeName }}</el-descriptions-item>
                            <el-descriptions-item label="状态">
                                <div style="display: flex; align-items: center">
                                    {{ result.Credit_CommercialBill_StateName }}
                                    <templatete v-if="result.Credit_CommercialBill_StateChange == 'true'">
                                        <span style="margin: 0 6px">变更：</span>
                                        <el-select v-model="result.Credit_CommercialBill_State" placeholder="请选择" class="el-select-medium" value-key="ID" filterable>
                                            <template>
                                                <el-option v-for="item in result.SelectState" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                                            </template>
                                        </el-select>
                                        <el-button type="primary" style="margin: 0 6px" @click="getUpdateCreditCommercialBillState()">更改</el-button>
                                    </templatete>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item label="分支机构">{{ result.Credit_CommercialBill_OfficeName }}</el-descriptions-item>
                            <el-descriptions-item label="经办人">
                                <div style="display: flex; align-items: center">
                                    {{ result.Credit_CommercialBill_AgentName }}
                                    <template v-if="result.Credit_CommercialBill_AgentChange == 'true'">
                                        <span style="margin: 0 6px">变更：</span>
                                        <el-select v-model="result.Credit_CommercialBill_Agent" placeholder="请选择" class="el-select-medium" value-key="ID" filterable>
                                            <template>
                                                <el-option v-for="item in Control_Agentopt" :key="item.ID" :label="item.ShowName" :value="item.ID"></el-option>
                                            </template>
                                        </el-select>
                                        <el-button type="primary" style="margin: 0 6px" @click="getUpdateCommercialBillAgent()">更改</el-button>
                                    </template>
                                </div>
                            </el-descriptions-item>
                            <el-descriptions-item label="创建人">{{ result.Credit_CommercialBill_AddUserName }}</el-descriptions-item>
                            <el-descriptions-item label="距到期天数">{{ result.Credit_CommercialBill_ExpireDate }}</el-descriptions-item>
                            <el-descriptions-item label="项目进展" v-if="result.ProgressState == 'true'">
                                <div style="display: flex; align-items: center">
                                    <el-input v-model="remarks" placeholder="" clearable class="el-select-medium"></el-input>
                                    <el-button type="primary" style="margin: 0 6px" @click="getUpdateCommercialBillProgress()">保存</el-button>
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>

                    <el-collapse-item title="进展明细及附件" name="2">
                        <el-descriptions title="" :column="1" border size="medium" labelClassName="custom-label">
                            <el-descriptions-item label="项目进展">
                                <el-table :data="ControlProgressLog" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                                    <el-table-column prop="Addtime" label="时间" align="center" width="120"></el-table-column>
                                    <el-table-column prop="UserName" label="操作人" align="center"></el-table-column>
                                    <el-table-column prop="Remarks" label="备注" align="center" show-overflow-tooltip></el-table-column>
                                </el-table>
                            </el-descriptions-item>
                            <el-descriptions-item label="状态变更">
                                <el-table :data="ControlStateLog" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                                    <el-table-column prop="Addtime" label="时间" align="center" width="120"></el-table-column>
                                    <el-table-column prop="UserName" label="操作人" align="center"></el-table-column>
                                    <el-table-column prop="Remarks" label="备注" align="center" show-overflow-tooltip></el-table-column>
                                </el-table>
                            </el-descriptions-item>
                            <el-descriptions-item label="附件列表">
                                <el-table :data="file" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                    <el-table-column prop="No" label="序号" align="center" width="80"></el-table-column>
                                    <el-table-column prop="Addtime" label="时间" width="120" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Addtime | formatDate }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Type" label="类型" align="center"></el-table-column>
                                    <el-table-column prop="UserName" label="操作人" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="Remarks" label="附件" align="center">
                                        <template slot-scope="scope">
                                            <div class="operation-bar" v-if="scope.row.Remarks && scope.row.Remarks != '--'">
                                                <span class="operation-bar-block operation-bar-block" @click="downFile(scope.row.Remarks)">打开</span>
                                            </div>
                                            <span v-else>{{ scope.row.Remarks }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="operation" label="操作" align="center">
                                        <template slot-scope="scope">
                                            <div class="operation-bar" v-if="scope.row.operation == '删除'">
                                                <span class="operation-bar-block operation-bar-block-del" @click="getDelCommercialBillFile(scope.row)">删除</span>
                                            </div>
                                            <span v-else>{{ scope.row.operation }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-descriptions-item>
                            <el-descriptions-item label="附件上传" v-if="result.UploadState == 'true'">
                                <Hwupload ref="Hwupload" v-if="isDetail"></Hwupload>
                                <div style="margin-top: 10px">
                                    <el-button slot="trigger" type="primary" @click="getUpdateCommercialBillFile()">保存附件</el-button>
                                </div>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="onDetailClose()">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Hwupload from '@/components/Hwupload/index.vue'
export default {
  components: {
    Hwupload,
  },
  props: {
    isDetail: {
      type: Boolean,
      default: () => true
    },
    id: {
      type: [Number, String],
      default: ""
    }
  },
  watch: {
    isDetail (newval, oldval) {
      console.log(newval, oldval, "open")
      if (newval) {
        this.activeNames = ['1']
        this.getCreditCommercialBillByID()
        this.getOfficeMemberSelectOption()
      }
    }
  },

  data () {
    return {
      remarks: '', //项目进展
      filePath: '', //附件路径
      result: {
        "Credit_CommercialBill_AddTime": "",
        "SelectStateIndex": 0,
        "Credit_CommercialBill_AddUserName": "",
        "Credit_CommercialBill_PaymentIDChange": "true",
        "Credit_CommercialBill_StateChange": "true",
        "Credit_CommercialBill_AgentChange": "true",
        "ProgressState": "true",
        "UploadState": "true",
        "SelectState": [],
        "Credit_CommercialBill_ID": "",
        "Credit_CommercialBill_SN": "",
        "Credit_CommercialBill_State": 1,
        "Credit_CommercialBill_StateName": "",
        "Credit_CommercialBill_ProjectMoney": "",
        "Credit_CommercialBill_PaymentID": "",
        "Credit_CommercialBill_Balance": "",
        "Credit_CommercialBill_IssueDate": "",
        "Credit_CommercialBill_DueDate": "",
        "Credit_CommercialBill_Acceptor": "",
        "Credit_CommercialBill_FormerEndorser": "",
        "Credit_CommercialBill_Type": 1,
        "Credit_CommercialBill_TypeName": "",
        "Credit_CommercialBill_OfficeID": 149,
        "Credit_CommercialBill_OfficeName": "",
        "Credit_CommercialBill_LargeRegionID": 27,
        "Credit_CommercialBill_LargeRegionName": "",
        "Credit_CommercialBill_CustomerName": "",
        "Credit_CommercialBill_CustomerUniformCode": "",
        "Credit_CommercialBill_Agent": 54,
        "Credit_CommercialBill_AgentName": "",
        "Credit_CommercialBill_ExpireDate": "1"
      },
      file: [],
      activeNames: ['1'],
      Control_Agentopt: [],
      ControlProgressLog: [],
      ControlStateLog: [],
    }
  },
  methods: {
    /*
    获取详情信息
    */
    getCreditCommercialBillByID () {
      this.$newsApi.getCreditCommercialBillByID({ id: this.id }).then(res => {
        if (res.data.Resultcode == 0) {
          this.result = res.data.data
          this.getCreditCommercialBillProgressLog()
          this.getCreditCommercialBillStateLog()
          this.getCreditCommercialBillAttachmentsLog()
        }
      })
    },
    /*
    查询经办人
    */
    getOfficeMemberSelectOption () {
      this.$newsApi.getOfficeMemberSelectOption().then(res => {
        if (res.data.Resultcode == 0) {
          this.Control_Agentopt = res.data.data
        }
      })
    },
    /*
     项目进展添加
    */
    getUpdateCommercialBillProgress () {
      this.$newsApi.getUpdateCommercialBillProgress({ remarks: this.remarks, ID: this.result.Credit_CommercialBill_ID }).then(res => {
        if (res.data.Resultcode == 0) {
          this.remarks = ""
          this.getCreditCommercialBillProgressLog()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }
      })
    },
    /*
    经办人变更
    */
    getUpdateCommercialBillAgent () {
      this.$newsApi.getUpdateCommercialBillAgent({
        id: this.result.Credit_CommercialBill_ID, agent: this.result.Credit_CommercialBill_Agent
      }).then(res => {
        if (res.data.Resultcode == 0) {
          this.getCreditCommercialBillByID()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }
      })
    },
    /*
    混合付款ID
    */
    getUpdateCreditCommercialBillPaymentID () {
      this.$newsApi.getUpdateCreditCommercialBillPaymentID({
        id: this.result.Credit_CommercialBill_ID, paymentid: this.result.Credit_CommercialBill_PaymentID
      }).then(res => {
        if (res.data.Resultcode == 0) {
          this.getCreditCommercialBillByID()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }
      })
    },
    /*
    状态变更
    */
    getUpdateCreditCommercialBillState () {
      this.$newsApi.getUpdateCreditCommercialBillState({
        id: this.result.Credit_CommercialBill_ID,
        status: this.result.Credit_CommercialBill_State
      }).then(res => {
        if (res.data.Resultcode == 0) {
          this.getCreditCommercialBillByID()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }
      })
    },
    /*
  获取附件列表
  */
    getCreditCommercialBillAttachmentsLog () {
      this.$newsApi.getCreditCommercialBillAttachmentsLog({
        id: this.result.Credit_CommercialBill_ID,
      }).then(res => {
        if (res.data.Resultcode == 0) {
          this.file = res.data.data
        }
      })
    },
    /*
    获取项目进展列表
  */
    getCreditCommercialBillProgressLog () {
      this.$newsApi.getCreditCommercialBillProgressLog({
        id: this.result.Credit_CommercialBill_ID,
      }).then(res => {
        if (res.data.Resultcode == 0) {
          this.ControlProgressLog = res.data.data
        }
      })
    },
    /*
   获取状态变更列表
   */
    getCreditCommercialBillStateLog () {
      this.ControlStateLog = []
      this.$newsApi.getCreditCommercialBillStateLog({
        id: this.result.Credit_CommercialBill_ID,
      }).then(res => {
        if (res.data.Resultcode == 0) {
          this.ControlStateLog = res.data.data
        }
      })
    },

    /*
     信控项目详情附件上传
   */
    getUpdateCommercialBillFile () {
      this.filePath = this.$refs.Hwupload.filePath
      this.$newsApi.getUpdateCommercialBillFile({ remarks: this.filePath, ID: this.result.Credit_CommercialBill_ID }).then(res => {
        if (res.data.Resultcode == 0) {
          this.filePath = ""
          this.$refs.Hwupload.handleRemove()
          this.getCreditCommercialBillAttachmentsLog()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        }
      })
    },
    /*
      信控项目详情附件删除
    */
    getDelCommercialBillFile (items) {
      this.$confirm('删除后不可恢复，确定删除么?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$newsApi.getDelCommercialBillFile({ log_id: items.LogID, ID: this.result.Credit_CommercialBill_ID }).then(res => {
          if (res.data.Resultcode == 0) {
            this.getCreditCommercialBillAttachmentsLog()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          }
        })
      }).catch(() => {
      })
    },
    onDetailClose () {
      this.$emit('onDetailClose')
    },
    downFile (par) {
      window.open(par)
    },
  }
}
</script>

<style scoped lang="scss">
/* #f5f7fa */

.rows {
    width: 389px;
}
.hw-content {
    padding: 0px 20px;
}
</style>